import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { callable } from '../data/useEntitlement';
import { documentLinkFrom } from '../data/documentLinks';

// The signed-in studio's `documentLink` (#621): an invoice or a report as the
// server's PDF, by link. data/documentLinks.js is the whole of it; this binds
// it to the callable, apart, so the components that open a PDF load without
// Firebase under jest.
export default function useDocumentLink() {
  const { user } = useAuth();
  const uid = user?.uid || null;
  return useMemo(() => documentLinkFrom(uid ? callable('documentLink') : null), [uid]);
}
